/**
 * Response from the geocode API
 */
export interface GeocodeResponse {
  address_full: AddressFull
  address: string
  status: string
  source: string
  code: number
  in_polygon: boolean
  polygon: Polygon
}

/**
 * Polygon information for a location
 */
export interface Polygon {
  description: string
  structured_formatting: StructuredFormatting
  coordinates: Location[]
}

/**
 * Formatted text for addresses
 */
export interface StructuredFormatting {
  main_text: string
  secondary_text: string
}

/**
 * Full address information
 */
export interface AddressFull {
  results: AddressResult[]
  status: string
}

/**
 * Address result from geocode API
 */
export interface AddressResult {
  formatted_address: string
  display_name: string
  place_id: string
  geometry: Geometry
  address_components: AddressComponent[]
  source: string
}

/**
 * Address component for more specific parts of an address
 */
export interface AddressComponent {
  long_name: string
}

/**
 * Geometry information with location
 */
export interface Geometry {
  location: Location
}

/**
 * Location coordinates
 */
export interface Location {
  lat: number
  lng: number
}
